import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('serviceIntervalField');

    return {
        INTERVAL_OUT_OF_RANGE_ERROR: ({ max, min }: { max: number; min: number }) =>
            t('intervalOutOfRangeError', { max, min }),
        INTERVAL_REQUIRED_ERROR: t('intervalRequiredError')
    };
};

export default useTranslation;
